import {
    NON_ISSUE_RAW_MATERIAL_STOCK_REPORT_REQUEST,
    NON_ISSUE_RAW_MATERIAL_STOCK_REPORT_SUCCESS,
    NON_ISSUE_RAW_MATERIAL_STOCK_REPORT_FAILURE,
    NON_ISSUE_RAW_MATERIAL_STOCK_FILTER_REPORT_REQUEST,
    NON_ISSUE_RAW_MATERIAL_STOCK_FILTER_REPORT_SUCCESS,
    NON_ISSUE_RAW_MATERIAL_STOCK_FILTER_REPORT_FAILURE,
  } from "../types/non-issue-raw-material-stock-report-types";
  
  const initialState = {
    nonIssueRawMaterialStockReport: {},
    nonIssueRawMaterialStockFilterReport: {},
    loading: false,
    error: null,
  };
  
  const nonIssueRawMaterialStockReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case NON_ISSUE_RAW_MATERIAL_STOCK_REPORT_REQUEST, NON_ISSUE_RAW_MATERIAL_STOCK_FILTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case NON_ISSUE_RAW_MATERIAL_STOCK_REPORT_SUCCESS: {
        return {
          ...state,
          nonIssueRawMaterialStockReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case NON_ISSUE_RAW_MATERIAL_STOCK_FILTER_REPORT_SUCCESS: {
        return {
          ...state,
          nonIssueRawMaterialStockFilterReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case NON_ISSUE_RAW_MATERIAL_STOCK_REPORT_FAILURE, NON_ISSUE_RAW_MATERIAL_STOCK_FILTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default nonIssueRawMaterialStockReportReducer;
  